import * as yup from "yup";

export const paneValidationSchema = yup.object().shape({
  title: yup.string().required("Title can't be blank"),
  schema: yup.object().required("Please select a DB schema").nullable(),
  table: yup.object().required("Please select a table"),
  chart_type: yup.object().required("Please select a chart type"),
  namekey: yup
    .array()
    .of(yup.object())
    .min(1, "Please select a column")
    .required("Please select a column")
    .nullable(),
  valuekey: yup
    .array()
    .of(yup.object().nullable())
    .when("chart_type.value", {
      is: type => type !== "tabular",
      then: yup
        .array()
        .of(yup.object())
        .min(1, "Please add a metric")
        .required("Please add a metric")
        .nullable(),
    }),
  row_limit: yup
    .object()
    .shape({
      label: yup.string().required(),
      value: yup
        .number()
        .typeError("Please select a valid row limit")
        .required(),
    })
    .nullable()
    .required("Please select a row limit"),
});

export const modalValidationSchema = yup.object({
  column: yup.object().required("Please select a column"),
  aggregate: yup.object().required("Please select an aggregate function"),
});

export const sortByModalValidationSchema = yup.object({
  column: yup.object().required("Please select a column"),
  aggregate: yup.object().required("Please select an aggregate function"),
});

export const filterModalValidationSchema = yup.object({
  column: yup.object().required("Please select a column"),
  operator: yup.object().required("Please select an operator"),
  filterValue: yup.mixed().when("operator.value", {
    is: operator => operator?.includes("IN"),
    then: yup
      .array()
      .of(yup.object())
      .min(1, "Please select a value")
      .required("Please select a value"),
    otherwise: yup.string().when("operator.value", {
      is: operator => operator?.includes("NULL"),
      then: yup.string(),
      otherwise: yup.string().required("Enter a value"),
    }),
  }),
});

export const dashboardValidationSchema = yup.object({
  title: yup.string().required("Title can't be blank"),
});

export const pivotedDataFilterSchema = yup.object({
  conditions: yup.array().of(
    yup.object().shape({
      column: yup.object().required("Column name is required"),
      value: yup
        .array()
        .of(yup.object())
        .min(1, "Filter value is required")
        .required("Filter value is required"),
    })
  ),
});

export const npiValidationSchema = yup.object().shape({
  npi: yup
    .number()
    .typeError("NPI number must be digits")
    .min(
      1000000000,
      "You can only search by an exact NPI number, which is 10 digits long."
    )
    .max(
      10000000000,
      "You can only search by an exact NPI number, which is 10 digits long."
    )
    .required("Enter NPI number"),
});

export const survivorshipDomainBusinessRules = yup.object().shape({
  rule_no: yup
    .number()
    .typeError("Rule number must be a number")
    .required("Rule number is required"),
  rule: yup.string().required("Rule is required"),
  context: yup.object().required("Context is required").nullable(),
  ruleType: yup.string().required("Rule type is required"),
  sourceName: yup.object().nullable(),
  ruleCategory: yup.string().required("Rule category is required"),
  domain: yup.object().required("Domain is required").nullable(),
  cde: yup.object().required("CDE is required").nullable(),
  approver: yup.object().required("Approver is required").nullable(),
  approvalDate: yup.date().required("Approval date is required"),
});
